<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/match")
          i.fa.fa-gamepad
          span.ml-1 {{ $t("ui.match") }}
      b-breadcrumb-item
        router-link(to="/match/preaddmatchcmd")
          i.fas.fa-plus
          span.ml-1 {{ $t("ui.pre_add_match_cmd") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div(v-show="pageLvl == 'match'")
            div.row
              div.col-md-12.mb-1
                div.form-row
                  div.col-md-3.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        span {{ $tc("ui.leagues", 1) }}
                      b-form-select(v-model="consoleLeague" @change="consoleLeagueOnChanged($event)" autofocus)
                        option(value="" disabled selected) {{ $t("message.select_option") }}
                        option(v-for="cl in filterConsoleLeagueOption" v-bind:value="cl.value")
                          | {{ cl.text }}
                    small.text-danger.text-uppercase(v-if="feedback.consoleLeague") {{ feedback.consoleLeague }}
                  div.col-md-4.mb-1
                    b-input-group(size="sm" :disabled="consoleLeague" v-if="!ignoreTeam")
                      //- b-input-group-text(slot="prepend")
                      //-   span {{ $tc("ui.teams", 1) }}
                      vue-multi-select(
                        v-model="consoleTeam"
                        search
                        :btnLabel="btnLabel"
                        :filters="filters"
                        :options="options"
                        @selectionChanged="getSpecialMatchDetail()"
                        :selectOptions="consoleTeamOption")
                    small.text-danger.text-uppercase(v-if="feedback.consoleTeam && !ignoreTeam") {{ feedback.consoleTeam }}
                  div.col-md-2.mb-1
                    //- SubmitButton(
                    //-   :loading="loading"
                    //-   icon="fa fa-search"
                    //-   :text="$t('ui.check')"
                    //-   type="button"
                    //-   @click="getSpecialMatchDetail()"
                    //-   variant="success"
                    //-   size="sm"
                    //-   ).mr-2
                    SubmitButton(
                      :loading="loading"
                      icon="fas fa-save"
                      :text="$t('ui.save')"
                      type="button"
                      @click="addMatch()"
                      variant="primary"
                      size="sm"
                      v-if="showSpecialMatchDetail"
                      ).mr-2
          div(v-show="pageLvl == 'league'")
            div.row
              div.col-md-12.mb-1
                div.form-row
                  div.col-md-2.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.fas.fa-basketball-ball
                      b-form-select(v-model="sportType" autofocus)
                        option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                          | {{ sportInfo.sport_type }}
                  div.col-md-4.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.fa.fa-search
                      DebounceInput(required type="text" v-model="matchSearch" :placeholder="$t('message.search_by_league_name')")
                  div.col-md-2.mb-1
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="id") {{ $t("ui.league_id") }}
                      b-form-radio(value="name") {{ $t("ui.league_name") }}
            div.row
              div.col-md-12.mb-1
                div.form-row
                  //- div.col-md-2.mb-1
                  //-   b-input-group(size="sm")
                  //-     b-input-group-text(slot="prepend")
                  //-       i.far.fa-clock
                  //-     b-form-select(v-model="marketType" @change="marketOnChange($event)")
                  //-       option(value="") {{ $t('ui.all') }}
                  //-       option(value="early") {{ $t('ui.early') }}
                  //-       option(value="today") {{ $t('ui.today') }}
                  //-       option(value="live") {{ $t("ui.live") }}
                  //- div.col-md-3.mb-1
                  //-   b-input-group(size="sm")
                  //-     b-input-group-text(slot="prepend")
                  //-       i.fas.fa-sort
                  //-     b-form-select(v-model="sortKey")
                  //-       option(value="match_id") {{ $t('ui.id') }}
                  //-       option(value="sport_type") {{ $tc('ui.sports', 1) }}
                  //-       option(value="league_name") {{ $tc("ui.leagues", 1) }}
                  //-       option(value="match_date_time") {{ $t("ui.match_datetime") }}
                  //-     b-form-select(v-model="sortType")
                  //-       option(value="asc") {{ $t("ui.ascending") }}
                  //-       option(value="desc") {{ $t("ui.descending") }}
                  div.col-md-2.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        span {{ $t("ui.from") }}
                      date-picker(v-model="startDate" :config="locale")
                  div.col-md-2.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        span {{ $t("ui.to") }}
                      date-picker(v-model="endDate" :config="locale")
                  div.col-md-2.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        span {{ $t("ui.linked") }}
                      b-form-select(v-model="linked")
                        option(value="") {{ $t('ui.all') }}
                        option(value="true") {{ $t('ui.linked') }}
                        option(value="false") {{ $t('ui.not_linked') }}
                  div.col-md-2.mb-1
                    SubmitButton(
                      :loading="loading"
                      icon="fa fa-search"
                      :text="$t('ui.search')"
                      type="button"
                      @click="searchLeague"
                      variant="success"
                      size="sm"
                      ).mr-2
        div.card-body
          div(v-if="pageLvl == 'league'")
            div.row.mb-5
              div.col-6
                div.row.mb-2
                  div.col-md-10
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.fas.fa-search
                      DebounceInput(required type="text" v-model="leagueTblSearch" :placeholder="$t('message.search_by_team_name')").mr-1
                      b-form-radio-group(
                        buttons
                        v-model="leagueTblFilterBy"
                        size="sm"
                        button-variant="outline-info"
                      )
                        b-form-radio(value="league_id") {{ $t("ui.id") }}
                        b-form-radio(value="league_name") {{ $t("ui.name") }}
                  div.col-md-2.text-right
                    SubmitButton(
                      :loading="loading"
                      icon="icon-arrow-right"
                      :text="$t('ui.next')"
                      type="button"
                      @click="getLinkedMatchList(true)"
                      variant="info"
                      size="sm"
                      v-show="isShowLeagueNextBtn && pageLvl == 'league'"
                      )
                div.row.mb-1
                  div.col-12.clusterize
                    div#tblLeague.clusterize-scroll
                      table.tablex(v-columns-resizable)
                        thead
                          tr
                            th.sticky-position(width=34 style="z-index: 10;")
                              span
                                input(type="checkbox" @click="rowSelect('all', 'league')" v-model="leagueAllSelected").checkbox
                            th.sticky-position(width=80 @click="sortOrder('league_id', 'league')")
                              span {{ $t('ui.id') }}
                              i(:class="changeSortKey('league_id', 'league')")
                            th.sticky-position(width=100 @click="sortOrder('sport_type', 'league')")
                              span {{ $tc('ui.sports', 1) }}
                              i(:class="changeSortKey('sport_type', 'league')")
                            th.sticky-position(@click="sortOrder('league_name', 'league')")
                              span {{ $tc("ui.leagues", 1) }}
                              i(:class="changeSortKey('league_name', 'league')")
                        tbody.clusterize-content
                          tr(v-if="leagueList.length == 0")
                            td(colspan="4").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in filterLeagueList"
                            @click="rowSelect(item, 'league')"
                            :class="{ 'selectedRow' : selectedRow(item) }"
                            )
                            td
                              span
                                input(type="checkbox" v-model="item.checked" @click="rowSelect(item, 'league')").checkbox
                            td
                              span {{ item.league_id }}
                            td
                              span {{ item.sport_type }}
                            td
                              span {{ item.league_name }}
              div.col-6
                div.row.mb-2
                  div.col-md-10
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.fas.fa-search
                      DebounceInput(required type="text" v-model="matchTblSearch" :placeholder="$t('message.search_by_team_name')").mr-1
                      b-form-radio-group(
                        buttons
                        v-model="matchTblFilterBy"
                        size="sm"
                        button-variant="outline-info"
                      )
                        b-form-radio(value="match_id") {{ $t("ui.id") }}
                        b-form-radio(value="league_name") {{ $tc("ui.leagues", 1) }}
                        b-form-radio(value="home_team") {{ $t("ui.home") }}
                        b-form-radio(value="away_team") {{ $t("ui.away") }}
                  div.col-md-2.text-right
                    SubmitButton(
                      :loading="loading"
                      icon="icon-arrow-right"
                      :text="$t('ui.next')"
                      type="button"
                      @click="getPreAddMatchList()"
                      variant="info"
                      size="sm"
                      v-show="isShowMatchNextBtn && pageLvl == 'league'"
                      )
                div.row.mb-1
                  div.col-12.clusterize
                    div#tblMatch.clusterize-scroll
                      table.tablex(v-columns-resizable)
                        thead
                          tr
                            th.sticky-position(width=34 style="z-index: 10;")
                              span
                                input(type="checkbox" @click="rowSelect('all', 'match')" v-model="matchAllSelected").checkbox
                            th.sticky-position(width=80 @click="sortOrder('match_id', 'match')")
                              span {{ $t('ui.id') }}
                              i(:class="changeSortKey('match_id', 'match')")
                            th.sticky-position(width=100 @click="sortOrder('sport_type', 'match')")
                              span {{ $tc('ui.sports', 1) }}
                              i(:class="changeSortKey('sport_type', 'match')")
                            th.sticky-position(@click="sortOrder('league_name', 'match')")
                              span {{ $tc('ui.leagues', 1) }}
                              i(:class="changeSortKey('league_name', 'match')")
                            th.sticky-position(width=90 @click="sortOrder('match_date', 'match')")
                              span {{ $t('ui.short.match_date') }}
                              i(:class="changeSortKey('match_date', 'match')")
                            th.sticky-position(@click="sortOrder('home_team', 'match')")
                              span {{ $t('ui.home') }}
                              i(:class="changeSortKey('home_team', 'match')")
                            th.sticky-position(@click="sortOrder('away_team', 'match')")
                              span {{ $t('ui.away') }}
                              i(:class="changeSortKey('away_team', 'match')")
                        tbody.clusterize-content
                          tr(v-if="matchList.length == 0")
                            td(colspan="7").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in filterMatchList"
                            @click="rowSelect(item, 'match')"
                            :class="{ 'selectedRow' : selectedRow(item) }"
                            )
                            td
                              span
                                input(type="checkbox" v-model="item.checked" @click="rowSelect(item, 'match')").checkbox
                            td
                              span {{ item.match_id }}
                            td
                              span {{ item.sport_type }}
                            td
                              span(:title="item.league_name + ' [' + item.league_id + ']'") {{ item.league_name }}
                            td
                              span {{ getDate(item.match_date) }}
                            td
                              span(:title="item.home_team + ' [' + item.home_id + ']'") {{ item.home_team }}
                            td
                              span(:title="item.away_team + ' [' + item.away_id + ']'") {{ item.away_team }}
          div(v-if="pageLvl == 'match'")
            div.mb-1
              SubmitButton(
                :loading="loading"
                icon="icon-arrow-left"
                :text="$t('ui.back')"
                type="button"
                @click="backToLeagueLvl"
                variant="secondary"
                size="sm"
                ).mb-1.mr-1
            div.row.mb-5(v-if="showSpecialMatchDetail")
              div.col-12
                div.row.mb-1
                  div.col-12
                    div.row
                      div.col-md-12.mb-1
                        span.font-weight-bolder.text-uppercase {{ $t('ui.match_info') }}
                    div.row.clusterize
                      .clusterize-scroll.col-md-12.mb-1
                        table.tablex(style="width: 100%;" v-columns-resizable)
                          thead
                            tr
                              th.sticky-position(width=80)
                                span {{ $tc('ui.sports', 1) }}
                              th.sticky-position
                                span {{ $tc('ui.leagues', 1) }}
                              th.sticky-position
                                span {{ $t('ui.home') }}
                              th.sticky-position
                                span {{ $t('ui.away') }}
                              //- th.sticky-position(width=60)
                              //-   span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                              th.sticky-position(width=80)
                                span {{ $t("ui.short.match_date") }}
                              th.sticky-position(width=80)
                                span {{ $t("ui.short.match_time") }}
                          tbody.clusterize-content
                            tr(v-for="(info, index) in filterSpecialMatchList")
                              td
                                span {{ info.parent_sport_type }}
                              td
                                span(:title="info.prefer_league_name") {{ info.prefer_league_name }}
                              td
                                span(:title="info.prefer_home_name") {{ info.prefer_home_name }}
                              td
                                span(:title="info.prefer_away_name") {{ info.prefer_away_name }}
                              //- td
                              //-   span {{ info.parent_market_type }}
                              td
                                span {{ $moment(info.parent_match_date).format("YYYY-MM-DD") }}
                              td
                                span {{ info.parent_match_time }}
</template>
<script>
import config from "@/config";
import preadd from "@/preaddcmd";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import VueTimepicker from 'vue2-timepicker';
import vueMultiSelect from 'vue-multi-select';
import { required, alphaNum, sameAs, requiredIf } from "vuelidate/lib/validators";
import { match } from 'minimatch';
const notEmptyOrSelected = (value) => (value != '' || value != 0 || value.length > 0);

export default {
  components: {
    SubmitButton,
    DebounceInput,
    VueTimepicker,
    vueMultiSelect
  },
  data: () => ({
    loading: false,
    sportType: 1,
    sportList: [],
    leagueList: [],
    preAddMatchList: [],
    filterBy: "name",
    leagueTblFilterBy: "league_name",
    matchTblFilterBy: "league_name",
    linked: "",
    marketType: "",
    leagueSortKey: "league_name",
    leagueSortType: "asc",
    matchSortKey: "league_name",
    matchSortType: "asc",
    specialSortKey: "league_name",
    specialSortType: "asc",
    leagueTblSearch: "",
    matchTblSearch: "",
    matchTotalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed,
      consoleLeague: "",
      consoleTeam: "",
      timeout: null
    },
    matchSearch: "",
    matchTblSearch: "",
    consoleType: "",
    startDate: null,
    endDate: null,
    matchDate: null,
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    matchTime: {
      hh: '12',
      mm: '00',
      A: 'PM',
    },
    sboLeague: "",
    ibcLeague: "",
    sboHome: "",
    ibcHome: "",
    sboAway: "",
    ibcAway: "",
    consoleLeagueOption: preadd.specificOption,
    consoleLeague: "",
    consoleTeamOption: [],
    consoleTeam: [],
    preferId: 'ALL',
    matchList: [],
    specialMatchList: [],
    showSpecialMatchDetail: false,
    pageLvl: "league",
    btnLabel: values => `${values.length} options selected`,
    values: [],
    options: {
      multi: true,
      // labelName: 'text',
      // labelValue: 'value'
    },
    filters: [{
      nameAll: 'Select all',
      nameNotAll: 'Deselect all',
      func() {
        return true;
      },
    },
    {
      nameAll: 'Select 1-15',
      nameNotAll: 'Deselect 1-15',
      func(elem) {
        return elem.val <= 15 && elem.val >= 1;
      },
    },
    {
      nameAll: 'Select 16-26',
      nameNotAll: 'Deselect 16-26',
      func(elem) {
        return elem.val <= 26 && elem.val >= 16;
      },
    }],
    las: false,
    mas: false,
    ignoreTeam: false,
    includeSubMatch: false
  }),
  validations: {
    consoleLeague: {
      required,
      notEmptyOrSelected
    },
    consoleTeam: {
      required : requiredIf(function () {
        return !this.ignoreTeam;
      }),
      notEmptyOrSelected : requiredIf(function () {
        return !this.ignoreTeam;
      })
    }
  },
  computed: {
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    },
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    todayWD() {
      return this.$moment(new Date).add(-12, 'hours').format('YYYY-MM-DD');
    },
    tomorrowWD() {
      return this.$moment(new Date).add(1, 'days').add(-12, 'hours').format('YYYY-MM-DD');
    },
    isShowLeagueNextBtn() {
      if (this.leagueList.filter(item => { return item.checked == true; }).length > 0)
        return true;

      return false;
    },
    isShowMatchNextBtn() {
      if (this.matchList.filter(item => { return item.checked == true; }).length > 0)
        return true;

      return false;
    },
    filterConsoleLeagueOption() {
      return this.consoleLeagueOption.filter(item => {
        return item.sport == this.sportType;
      })
      .sort((a, b) => {
        return a.seq > b.seq ? 1 : -1;
      });
      // .sort((a, b) => {
      //   return a.text > b.text ? 1 : -1;
      // });
    },
    filterMatchList() {
      return this.matchList.filter(item => {
        if (this.matchTblFilterBy == "league_name") return item.league_name.toLowerCase().indexOf(this.matchTblSearch.toLowerCase()) > -1;
        else if (this.matchTblFilterBy == "home_team") return item.home_team.toLowerCase().indexOf(this.matchTblSearch.toLowerCase()) > -1;
        else if (this.matchTblFilterBy == "away_team") return item.away_team.toLowerCase().indexOf(this.matchTblSearch.toLowerCase()) > -1;
        else if (this.matchTblFilterBy == "match_id") return item.match_id.toString().indexOf(this.matchTblSearch) > -1;
      })
      .sort((a, b) => {
        if (this.matchSortType == 'asc')
          return a[this.matchSortKey] > b[this.matchSortKey] ? 1 : -1;
        else
          return a[this.matchSortKey] < b[this.matchSortKey] ? 1 : -1;
      });
    },
    filterLeagueList() {
      return this.leagueList.filter(item => {
        if (this.leagueTblFilterBy == "league_name") return item.league_name.toLowerCase().indexOf(this.leagueTblSearch.toLowerCase()) > -1;
        else if (this.leagueTblFilterBy == "league_id") return item.league_id.toString().indexOf(this.leagueTblSearch) > -1;
      })
      .sort((a, b) => {
        if (this.leagueSortType == 'asc')
          return a[this.leagueSortKey] > b[this.leagueSortKey] ? 1 : -1;
        else
          return a[this.leagueSortKey] < b[this.leagueSortKey] ? 1 : -1;
      });
    },
    filterSpecialMatchList()
    {
      let arr = this.specialMatchList.slice();
      return arr;
      // return arr.sort((a, b) => {
      //   if (this.specialSortType == 'asc')
      //     return a[this.specialSortKey] > b[this.specialSortKey] ? 1 : -1;
      //   else
      //     return a[this.specialSortKey] < b[this.specialSortKey] ? 1 : -1;
      // });
    },
    leagueAllSelected:
    {
      get() {
        if (this.leagueList.length == 0)
          return false;
        else if (this.leagueList.filter(item => { return item.checked == true; }).length == this.leagueList.length)
          return true;
        else if (this.las)
          return this.las;
        else
          return false;
      },
      set(value) {
        this.las = value;
      }
    },
    matchAllSelected:
    {
      get() {
        if (this.matchList.length == 0)
          return false;
        else if (this.matchList.filter(item => { return item.checked == true; }).length == this.matchList.length)
          return true;
        else if (this.mas)
          return this.mas;
        else
          return false;
      },
      set(value) {
        this.mas = value;
      }
    }
  },
  beforeDestroy() {
  },
  mounted: function() {
    this.getSportList();
    this.matchDate = this.today;
    this.startDate = this.yesterday;
    this.endDate = this.today;
  },
  methods: {
    marketOnChange(eventStatus) {
      if (eventStatus == '') {
        this.startDate = this.yesterday;
        this.endDate = this.today;
      }
      else if (eventStatus == 'early') {
        this.startDate = this.tomorrowWD;
        this.endDate = this.tomorrowWD;
      } else if (eventStatus == 'today' || eventStatus == 'live') {
        this.startDate = this.todayWD;
        this.endDate = this.todayWD;
      }
    },
    sortOrder(key, type) {
      if (type == 'league') {
        if (this.leagueSortKey == key)
          this.leagueSortType = this.leagueSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.leagueSortKey = key;
          this.leagueSortType = 'asc';
        }
      } else if (type == 'match') {
        if (this.matchSortKey == key)
          this.matchSortType = this.matchSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.matchSortKey = key;
          this.matchSortType = 'asc';
        }
      } else if (type == 'special') {
        if (this.specialSortKey == key)
          this.specialSortType = this.specialSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.specialSortKey = key;
          this.specialSortType = 'asc';
        }
      }
    },
    changeSortKey(key, type) {
      if (type == 'league') {
        if (this.leagueSortKey != key)
          return 'fas fa-sort';
        else if (this.leagueSortKey == key && this.leagueSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.leagueSortKey == key && this.leagueSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'match') {
        if (this.matchSortKey != key)
          return 'fas fa-sort';
        else if (this.matchSortKey == key && this.matchSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.matchSortKey == key && this.matchSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'special') {
        if (this.specialSortKey != key)
          return 'fas fa-sort';
        else if (this.specialSortKey == key && this.specialSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.specialSortKey == key && this.specialSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    searchLeague() {
      this.leagueAllSelected = false;
      this.leagueList = [];
      this.matchAllSelected = false;
      this.matchList = [];
      this.getleagueList();
    },
    getleagueList: function() {
      this.pageLvl = "league";

      let url = config.matchLeagueListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.preaddmatch,
        sport_id: this.sportType,
        market_type: this.marketType,
        linked: this.linked == '' ? null : this.linked,
        filter_special: true,
        match_date_from: this.$moment(this.startDate).format("YYYY-MM-DD"),
        match_date_to: this.$moment(this.endDate).format("YYYY-MM-DD")
      };

      if (this.filterBy == "id") {
        json.league_id = this.matchSearch;
      } else {
        json.league_name = this.matchSearch;
      }

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.leagueList = response.data.tbl_match_league_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getDate(dateTime) {
      let convertDateFormat = new this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    selectedRow: function(info) {
      if (info.checked)
        return true;

      return false;
    },
    rowSelect: function(info, type) {
      if(type == "league") {
        if(info != "all") {
          setTimeout(() => {
            this.leagueList.filter(item => {
              return item.league_id == info.league_id
            }).map(function(x) {
              x.checked = !x.checked;
              return x;
            });
          }, 10);
        }
        else {
          setTimeout(() => {
            if (this.las) {
              this.leagueList.map(function(x) {
                x.checked = true;
                return x;
              });
            } else {
              this.leagueList.map(function(x) {
                x.checked = false;
                return x;
              });
            }

          }, 10);
        }
      } else if (type == "match") {
        if(info != "all") {
          setTimeout(() => {
            this.matchList.filter(item => {
              return item.match_id == info.match_id
            }).map(function(x) {
              x.checked = !x.checked;
              return x;
            });
          }, 10);
        }
        else {
          setTimeout(() => {
            if (this.mas) {
              this.matchList.map(function(x) {
                x.checked = true;
                return x;
              });
            } else {
              this.matchList.map(function(x) {
                x.checked = false;
                return x;
              });
            }
          }, 10);
        }
      }
    },
    getLinkedMatchList: function(isSearch) {
      this.pageLvl = "league";

      let url = config.matchListUrl();

      // reset current page to 1 when "Search" button is clicked..
      if (isSearch) this.currentLinkedMatchPage = 1;

      var list = [];
      var tempList = this.leagueList.filter(item => { return item.checked == true; });

      for(var i = 0; i < tempList.length; i++) {
        list.push(tempList[i].league_id);
      }

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.preaddmatch,
        sport_id: this.sportType,
        market_type: this.marketType,
        match_date_from: this.$moment(this.startDate).format("YYYY-MM-DD"),
        match_date_to: this.$moment(this.endDate).format("YYYY-MM-DD"),
        league_id_str: list.join(', '),
        linked: this.linked == '' ? null : this.linked,
        sort_key: this.matchSortKey,
        sort_type: this.matchSortType,
        pagination: false
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.matchList = response.data.tbl_match_list;
                this.matchTotalRow = this.matchList.length > 0 ? this.matchList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset() {
      this.consoleLeague = "";
      this.consoleTeam = [];
      this.specialMatchList = [];
      this.showSpecialMatchDetail = false;
    },
    getPreAddMatchList() {
      this.reset();

      let url = config.preAddMatchListUrl();

      var list = [];
      var tempList = this.matchList.filter(item => { return item.checked == true; });

      for(var i = 0; i < tempList.length; i++) {
        list.push(tempList[i].match_id);
      }

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.preaddmatch,
        match_id_str: list.join(', ')
      }

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.preAddMatchList = response.data.tbl_match_pre_add_list;
                console.log(this.preAddMatchList)

                if(this.preAddMatchList.length > 0) {
                  if (this.checkLinkage()) {
                    this.pageLvl = "match";
                    this.getSpecialMatchDetail();
                  } else
                    this.specialMatchList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    consoleLeagueOnChanged(e) {
      this.consoleTeamOption = preadd.specificList[e].teamOpt;
      this.consoleTeam = [];
      this.specialMatchList = [];
      this.includeSubMatch = this.consoleLeagueOption.filter(item => {
        return item.value.toLowerCase() == this.consoleLeague.toLowerCase();
      })[0].includeSubMatch;
      this.ignoreTeam = this.consoleLeagueOption.filter(item => {
        return item.value.toLowerCase() == this.consoleLeague.toLowerCase();
      })[0].ignoreTeam;

      if (this.ignoreTeam)
        this.getSpecialMatchDetail();
    },
    resetFeedback() {
      this.feedback.consoleLeague = "";
      this.feedback.consoleTeam = "";
    },
    checkLinkage() {
      for(var j = 0; j < this.preAddMatchList.length; j++) {
        if (this.preAddMatchList[j].ibc_parent_match_id) {
          if(!this.preAddMatchList[j].ibc_league_id) {
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.mapLeagueOfMatch", { name: this.preAddMatchList[j].parent_match_id }), "error");
            return false;
          } else if (!this.preAddMatchList[j].ibc_home_id) {
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.mapHomeOfMatch", { name: this.preAddMatchList[j].parent_match_id }), "error");
            return false;
          } else if (!this.preAddMatchList[j].ibc_away_id) {
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.mapAwayOfMatch", { name: this.preAddMatchList[j].parent_match_id }), "error");
            return false;
          }
        }

        if (this.preAddMatchList[j].sbo_parent_match_id) {
          if(!this.preAddMatchList[j].sbo_league_id) {
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.mapLeagueOfMatch", { name: this.preAddMatchList[j].parent_match_id }), "error");
            return false;
          } else if (!this.preAddMatchList[j].sbo_home_id) {
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.mapHomeOfMatch", { name: this.preAddMatchList[j].parent_match_id }), "error");
            return false;
          } else if (!this.preAddMatchList[j].sbo_away_id) {
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.mapAwayOfMatch", { name: this.preAddMatchList[j].parent_match_id }), "error");
            return false;
          }
        }
      }

      return true;
    },
    validate() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        return true;
      } else {
        this.loading = false;
        this.resetFeedback();
        clearTimeout(this.feedback.timeout);
        if (!this.$v.consoleLeague.required) {
          this.feedback.consoleLeague = this.$t("error.consoleLeagueRequired");
        }

        if (!this.$v.consoleLeague.notEmptyOrSelected) {
          this.feedback.consoleLeague = this.$t("error.consoleLeagueRequired");
        }

        if (!this.ignoreTeam) {
          if (!this.$v.consoleTeam.required) {
            this.feedback.consoleTeam = this.$t("error.consoleTeamRequired");
          }

          if (!this.$v.consoleTeam.notEmptyOrSelected) {
            this.feedback.consoleTeam = this.$t("error.consoleTeamRequired");
          }
        }

        this.feedback.timeout = setTimeout(() => {
          this.$v.$reset();
          this.resetFeedback();
        }, 10000);
      }

      return false;
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.preaddmatch
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = [];
                this.sportList = response.data.tbl_sport_list.filter(item => { return item.sport_id > 0; });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getSpecialTeamName (format, homeName, awayName, teamObj, sport) {

      if (format.includes('{special_1}') && teamObj.special_1)
        format = format.replace('{special_1}', teamObj.special_1);
      if (format.includes('{special_2}') && teamObj.special_2)
        format = format.replace('{special_2}', teamObj.special_2);
      if (format.includes('{special_3}') && teamObj.special_3)
        format = format.replace('{special_3}', teamObj.special_3);
      if (format.includes('{special_4}') && teamObj.special_4)
        format = format.replace('{special_4}', teamObj.special_4);
      if (sport != 2) {
        if (format.includes('{home_team}') && homeName)
          format = format.replace('{home_team}', homeName.replace("(n)", "").replace("(N)", "").trim());
        if (format.includes('{away_team}') && awayName)
          format = format.replace('{away_team}', awayName.replace("(n)", "").replace("(N)", "").trim());
      } else {
        if (format.includes('{home_team}') && homeName)
          format = format.replace('{home_team}', homeName.trim());
        if (format.includes('{away_team}') && awayName)
          format = format.replace('{away_team}', awayName.trim());
      }

      return format;

    },
    getIgnoreTeamTeamName (name, sport) {
      if (sport != 2) {
        name = name.replace("(n)", "").replace("(N)", "").trim();
      }

      return name;
    },
    getSpecialLeagueName(leagueName, replaceWord) {
      var regEx = new RegExp(replaceWord, "ig"); //case insensitive

      if (replaceWord) {
        leagueName = leagueName.replace(regEx, "");
      }

      return leagueName;
    },
    getSpecialMatchDetail() {
      if (this.validate()) {
        this.showSpecialMatchDetail = true;

        this.specialMatchList = [];

        var cnt = 0;

        if (!this.ignoreTeam) {
          for(var j = 0; j < this.preAddMatchList.length; j++) {
            var obj = this.preAddMatchList[j];
            var marketType = this.getMarketType(obj.parent_match_date.trim(), obj.parent_match_time.trim());
            for(var i = 0; i < this.consoleTeam.length; i++) {
              var list = preadd.specificList[this.consoleLeague].team.filter(item => {
                return item.group.toLowerCase() == this.consoleTeam[i].name.toLowerCase();
              });
              for (var k = 0; k < list.length; k++) {
                var obj2 = preadd.specificList[this.consoleLeague];
                for (var l = 0; l < obj2.style; l++) {
                  this.specialMatchList.push({
                    prefer_league_name: this.getSpecialLeagueName(obj.prefer_league_name + obj2.preferLeague, obj2.rpLeagueWord),
                    sbo_league_name: obj.sbo_league_name ?  this.getSpecialLeagueName(obj.sbo_league_name.trim() + obj2.sboLeague, obj2.rpLeagueWord) : null,
                    ibc_league_name: obj.ibc_league_name ? this.getSpecialLeagueName(obj.ibc_league_name.trim() + obj2.ibcLeague, obj2.rpLeagueWord) : null,
                    sbo_parent_league_id: obj.sbo_league_id,
                    ibc_parent_league_id: obj.ibc_league_id,
                    prefer_home_name: obj.prefer_home_name && obj.prefer_away_name ? this.getSpecialTeamName(obj2.preferTeam[l].home, obj.prefer_home_name.trim(), obj.prefer_away_name.trim(), list[k], obj.parent_sport_id) : null,
                    sbo_home_name: obj.sbo_home_name && obj.sbo_away_name ? this.getSpecialTeamName(obj2.sboTeam[l].home, obj.sbo_home_name.trim(), obj.sbo_away_name.trim(), list[k], obj.parent_sport_id) : null,
                    ibc_home_name: obj.ibc_home_name && obj.ibc_away_name ? this.getSpecialTeamName(obj2.ibcTeam[l].home, obj.ibc_home_name.trim(), obj.ibc_away_name.trim(), list[k], obj.parent_sport_id) : null,
                    prefer_away_name: obj.prefer_home_name && obj.prefer_away_name ? this.getSpecialTeamName(obj2.preferTeam[l].away, obj.prefer_home_name.trim(), obj.prefer_away_name.trim(), list[k], obj.parent_sport_id) : null,
                    sbo_away_name: obj.sbo_home_name && obj.sbo_away_name ? this.getSpecialTeamName(obj2.sboTeam[l].away, obj.sbo_home_name.trim(), obj.sbo_away_name.trim(), list[k], obj.parent_sport_id) : null,
                    ibc_away_name: obj.ibc_home_name && obj.ibc_away_name ? this.getSpecialTeamName(obj2.ibcTeam[l].away, obj.ibc_home_name.trim(), obj.ibc_away_name.trim(), list[k], obj.parent_sport_id) : null,
                    league_prefer_provider: obj.league_prefer_provider,
                    home_prefer_provider: obj.home_prefer_provider,
                    away_prefer_provider: obj.away_prefer_provider,
                    parent_match_id: obj.parent_match_id,
                    sbo_parent_match_id: obj.sbo_parent_match_id,
                    ibc_parent_match_id: obj.ibc_parent_match_id,
                    parent_match_date: obj.parent_match_date,
                    parent_match_time: obj.parent_match_time,
                    // parent_market_type: obj.parent_market_type,
                    parent_market_type: marketType,
                    parent_sport_id: obj.parent_sport_id,
                    parent_sport_type: obj.parent_sport_type,
                    seq: cnt + 1
                  });

                  cnt++;
                }
              }
            }
          }
        } else {
          var cnt = 0;

          for(var j = 0; j < this.preAddMatchList.length; j++) {
            var marketType = this.getMarketType(this.preAddMatchList[j].parent_match_date.trim(), this.preAddMatchList[j].parent_match_time.trim());
            this.specialMatchList.push({
              prefer_league_name: this.preAddMatchList[j].prefer_league_name + preadd.specificList[this.consoleLeague].preferLeague,
              sbo_league_name: this.preAddMatchList[j].sbo_league_name ? this.preAddMatchList[j].sbo_league_name + preadd.specificList[this.consoleLeague].sboLeague : null,
              ibc_league_name: this.preAddMatchList[j].ibc_league_name ? this.preAddMatchList[j].ibc_league_name + preadd.specificList[this.consoleLeague].ibcLeague : null,
              sbo_parent_league_id: this.preAddMatchList[j].sbo_league_id,
              ibc_parent_league_id: this.preAddMatchList[j].ibc_league_id,
              // prefer_home_name: this.preAddMatchList[j].prefer_home_name ? this.preAddMatchList[j].prefer_home_name.replace("(n)", "").replace("(N)", "").trim() : null,
              // sbo_home_name: this.preAddMatchList[j].sbo_home_name ? this.preAddMatchList[j].sbo_home_name.replace("(n)", "").replace("(N)", "").trim() : null,
              // ibc_home_name: this.preAddMatchList[j].ibc_home_name ? this.preAddMatchList[j].ibc_home_name.replace("(n)", "").replace("(N)", "").trim() : null,
              // prefer_away_name: this.preAddMatchList[j].prefer_away_name ? this.preAddMatchList[j].prefer_away_name.replace("(n)", "").replace("(N)", "").trim() : null,
              // sbo_away_name: this.preAddMatchList[j].sbo_away_name ? this.preAddMatchList[j].sbo_away_name.replace("(n)", "").replace("(N)", "").trim() : null,
              // ibc_away_name: this.preAddMatchList[j].ibc_away_name ? this.preAddMatchList[j].ibc_away_name.replace("(n)", "").replace("(N)", "").trim() : null,
              prefer_home_name: this.preAddMatchList[j].prefer_home_name ? this.getIgnoreTeamTeamName(this.preAddMatchList[j].prefer_home_name, this.preAddMatchList[j].parent_sport_id) : null,
              sbo_home_name: this.preAddMatchList[j].sbo_home_name ? this.getIgnoreTeamTeamName(this.preAddMatchList[j].sbo_home_name, this.preAddMatchList[j].parent_sport_id) : null,
              ibc_home_name: this.preAddMatchList[j].ibc_home_name ? this.getIgnoreTeamTeamName(this.preAddMatchList[j].ibc_home_name, this.preAddMatchList[j].parent_sport_id) : null,
              prefer_away_name: this.preAddMatchList[j].prefer_away_name ? this.getIgnoreTeamTeamName(this.preAddMatchList[j].prefer_away_name, this.preAddMatchList[j].parent_sport_id) : null,
              sbo_away_name: this.preAddMatchList[j].sbo_away_name ? this.getIgnoreTeamTeamName(this.preAddMatchList[j].sbo_away_name, this.preAddMatchList[j].parent_sport_id) : null,
              ibc_away_name: this.preAddMatchList[j].ibc_away_name ? this.getIgnoreTeamTeamName(this.preAddMatchList[j].ibc_away_name, this.preAddMatchList[j].parent_sport_id) : null,
              league_prefer_provider: this.preAddMatchList[j].league_prefer_provider,
              home_prefer_provider: this.preAddMatchList[j].home_prefer_provider,
              away_prefer_provider: this.preAddMatchList[j].away_prefer_provider,
              parent_match_id: this.preAddMatchList[j].parent_match_id,
              sbo_parent_match_id: this.preAddMatchList[j].sbo_parent_match_id,
              ibc_parent_match_id: this.preAddMatchList[j].ibc_parent_match_id,
              parent_match_date: this.preAddMatchList[j].parent_match_date,
              parent_match_time: this.preAddMatchList[j].parent_match_time,
              // parent_market_type: this.preAddMatchList[j].parent_market_type,
              parent_market_type: marketType,
              parent_sport_id: this.preAddMatchList[j].parent_sport_id,
              parent_sport_type: this.preAddMatchList[j].parent_sport_type,
              seq: cnt + 1
            });

            cnt++;
          }
        }
      }
    },
    getMarketType(date, time) {
      if (this.$moment(new Date).format('YYYY-MM-DD HH:mm:ss') > this.$moment(date + ' ' + time, 'YYYY-MM-DD hh:mmA').format('YYYY-MM-DD HH:mm:ss')) {
        return 'today';
        // return 'live';
      } else {
        if (this.$moment(new Date).add(-12, 'hours').format('YYYY-MM-DD') == this.$moment(date + ' ' + time, 'YYYY-MM-DD hh:mmA').add(-12, 'hours').format('YYYY-MM-DD'))
          return 'today';
        else if (this.$moment(new Date).add(-12, 'hours').format('YYYY-MM-DD') < this.$moment(date + ' ' + time, 'YYYY-MM-DD hh:mmA').add(-12, 'hours').format('YYYY-MM-DD'))
          return 'early';
        else
          return '';
      }
    },
    addMatch() {
      let url = config.preAddMatchUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.preaddmatch,
        match_dt: this.specialMatchList,
        include_sub_match: this.includeSubMatch,
        provider: 'ALL'
      };

      console.log(json)

      //console.log(json);

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // this.$helpers.showDialog(this.$t("ui.combine.map_match"), this.$t("message.success"), "success");
                this.$snotify.success(this.$t("message.success"));
              } else {
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    backToLeagueLvl() {
      this.pageLvl = "league";
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}

u {
  text-decoration: none !important;
}


</style>